module.exports = __webpack_public_path__ + "static/media/popup-logo.c216eae4.png";